import React, { useRef } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const categories = [
  'All',
  'Hair Treatment',
  'Hair Massage',
  'Hair Treatment',
  'Hair Styling'
];

const ScrollableCategoryTabs = ({value,categories,setValue}) => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: direction === 'left' ? -200 : 200, behavior: 'smooth' });
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {/* Left Arrow */}
      <Button onClick={() => scroll("left")} sx={{ minWidth: 40 }}>
        <ArrowBackIosNewIcon />
      </Button>

      {/* Scrollable container */}
      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          overflowX: "auto",
          scrollbarWidth: "none", // for Firefox
          "&::-webkit-scrollbar": { display: "none" }, // for Chrome
          gap: 2,
          py: 1,
        }}
      >
        {" "}
        <Box
          sx={{
            flexShrink: 0,
            px: 2,
            py: 1,
            borderRadius: 2,
            backgroundColor: "#15057B",
            color: "white",
            fontWeight: 500,
            boxShadow: 2,
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              // textAlign: "center",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
            onClick={() => {
              setValue(0);
            }}
          >
            All
          </Typography>
        </Box>
        {categories.map((category, index) => (
          <Box
            key={index}
            onClick={() => {
              setValue(index + 1);
            }}
            sx={{
              flexShrink: 0,
              px: 2,
              py: 1,
              borderRadius: 2,
              backgroundColor: index + 1 === value ? "#15057B" : "#D7D4FF",
              color: index + 1 === value ? "white" : "#15057B",
              fontWeight: 500,
              boxShadow: index + 1 === value ? 2 : 1,
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                // textAlign: "center",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              {category.categoryName ?? ""}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Right Arrow */}
      <Button onClick={() => scroll("right")} sx={{ minWidth: 40 }}>
        <ArrowForwardIosIcon />
      </Button>
    </Box>
  );
};

export default ScrollableCategoryTabs;
